export default class vendor_website_templates {
  constructor() {
    this.page = $(".vendorWebsiteTemplatesPage");
    if (!this.page.length) {
      return;
    }

    this.templateList = $("#vendorWebsiteTemplateList");
    this.subdomainInput = $("#vendorWebsiteSubdomain");
    this.siteTitleInput = $("#vendorWebsiteSiteTitle");
    this.metaTitleInput = $("#vendorWebsiteMetaTitle");
    this.metaDescriptionInput = $("#vendorWebsiteMetaDescription");
    this.metaKeywordsInput = $("#vendorWebsiteMetaKeywords");
    this.seoBodyInput = $("#vendorWebsiteSeoBody");
    this.focusKeywordsInput = $("#vendorWebsiteFocusKeywords");
    this.serviceAreaInput = $("#vendorWebsiteServiceArea");
    this.saveBtn = $("#vendorWebsiteSaveBtn");
    this.generateSeoBtn = $("#vendorGenerateSeoBtn");
    this.selectedTemplateName = $("#vendorSelectedTemplateName");
    this.provisionStatusBadge = $("#vendorWebsiteProvisionStatus");
    this.notice = $("#vendorWebsiteNotice");
    this.primaryColorInput = $("#vendorWebsitePrimaryColor");
    this.secondaryColorInput = $("#vendorWebsiteSecondaryColor");
    this.typeLabel = $("#vendorTemplatesTypeLabel");
    this.previewBtn = $("#vendorWebsitePreviewBtn");
    
    this.instagramInput = $("#vendorWebsiteInstagram");
    this.facebookInput = $("#vendorWebsiteFacebook");
    this.whatsappInput = $("#vendorWebsiteWhatsapp");
    this.previewIframe = $("#vendorWebsiteLivePreview");
    this.previewLoader = $("#vendorWebsitePreviewLoader");

    this.templates = [];
    this.baseDomain = "locaso.in";
    this.selectedTemplateSlug = "";
    this.vendorType = "product";
    this.subdomainCheckTimeout = null;

    this.bindEvents();
    this.loadWebsiteBuilderData();
  }

  bindEvents = () => {
    this.templateList.on("click", ".vendor-template-card", this.onTemplateCardClick);
    this.subdomainInput.on("input", this.onSubdomainInput);
    this.saveBtn.on("click", this.saveSettings);
    this.generateSeoBtn.on("click", this.generateSeoContent);
    
    // Live Preview Sync
    this.primaryColorInput.on("input", this.syncLivePreview);
    this.secondaryColorInput.on("input", this.syncLivePreview);
    this.page.on("change", 'input[name="font_family"], input[name="border_radius"]', this.syncLivePreview);
  };

  loadWebsiteBuilderData = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getWebsiteBuilderData",
      headers: { Authorization: X_API_KEY },
      success: this.onWebsiteBuilderLoaded,
      error: () => {
        this.showNotice("Could not load website templates right now.", true);
      }
    });
  };

  onWebsiteBuilderLoaded = (res) => {
    this.templates = Array.isArray(res.templates) ? res.templates : [];
    this.baseDomain = (res.base_domain || "locaso.in").replace(/^https?:\/\//i, "").replace(/\/+$/, "");
    this.vendorType = res.vendor_type || "product";

    // Update UI labels
    const typeDisplay = this.vendorType.charAt(0).toUpperCase() + this.vendorType.slice(1);
    this.typeLabel.text(`${typeDisplay} Themes`);
    this.subdomainInput.siblings(".input-group-text").text("." + this.baseDomain);

    this.applySettings(res.settings || {});
    this.showNotice("Themes loaded successfully.");
  };

  renderTemplateCards = () => {
    this.templateList.empty();
    if (!this.templates.length) {
      this.templateList.html("<div class='col-12'><div class='alert alert-warning mb-0'>No templates available for your business type.</div></div>");
      return;
    }

    this.templates.forEach((template) => {
      const isSelected = template.slug === this.selectedTemplateSlug;
      const typeLabel = template.type || "universal";
      const icon = template.icon || "fa-solid fa-layer-group";
      const color = template.color || "#ff385c";

      const card = `
        <div class="col-12 col-md-6">
          <div class="vendor-template-card p-4 h-100 ${isSelected ? "active" : ""}" 
               data-template-slug="${template.slug}" 
               data-template-name="${template.name}">
            <div class="d-flex justify-content-between align-items-start mb-3">
              <div class="template-icon" style="${isSelected ? `background: ${color} !important; color: white !important;` : `color: ${color}; background-color: color-mix(in srgb, ${color}, transparent 90%);`}">
                <i class="${icon}"></i>
              </div>
              <div class="d-flex flex-column align-items-end pt-1">
                ${isSelected ? '<i class="fa-solid fa-circle-check text-red fs-4 mb-2"></i>' : ""}
                <span class="template-type-badge ${isSelected ? "bg-white text-dark shadow-sm" : "bg-light text-muted"}">
                  ${typeLabel}
                </span>
              </div>
            </div>
            <h5 class="fw-bold mb-2" style="letter-spacing: -0.01em;">${template.name}</h5>
            <p class="small text-muted mb-0" style="font-size: 0.85rem; line-height: 1.5; opacity: 0.8;">${template.tagline || ""}</p>
          </div>
        </div>
      `;
      this.templateList.append(card);
    });
  };

  applySettings = (settings) => {
    if (settings.selected_template) {
      this.selectedTemplateSlug = settings.selected_template;
    } else if (this.templates[0]) {
      this.selectedTemplateSlug = this.templates[0].slug;
    }

    this.subdomainInput.val(settings.subdomain || "");
    this.siteTitleInput.val(settings.site_title || "");
    this.primaryColorInput.val(settings.primary_color || "#ff385c");
    this.secondaryColorInput.val(settings.secondary_color || "#ffffff");
    this.metaTitleInput.val(settings.meta_title || "");
    this.metaDescriptionInput.val(settings.meta_description || "");
    this.metaKeywordsInput.val(settings.meta_keywords || "");
    this.seoBodyInput.val(settings.seo_body || "");
    this.instagramInput.val(settings.social_instagram || "");
    this.facebookInput.val(settings.social_facebook || "");
    this.whatsappInput.val(settings.social_whatsapp || "");

    if (settings.font_family) {
      $(`input[name="font_family"][value="${settings.font_family}"]`).prop("checked", true);
    }
    if (settings.border_radius) {
      $(`input[name="border_radius"][value="${settings.border_radius}"]`).prop("checked", true);
    }

    this.updateSelectedTemplateName();
    this.updateStatusBadge(settings.provision_status || "pending");
    this.initLivePreview(settings.subdomain || "");
    this.renderTemplateCards();
  };

  buildSubdomainURL = (subdomain, isPreview = false) => {
    if (!subdomain) return "";
    
    let protocol = window.location.protocol; // "http:" or "https:"
    
    try {
      const urlObj = new URL(baseURL);
      protocol = urlObj.protocol;
    } catch (e) {
      console.warn("Failed to parse baseURL:", e);
    }
    
    let url = `${protocol}//${subdomain}.${this.baseDomain}/`;
    
    if (isPreview) {
      url += `?preview=1&t=${Date.now()}`;
    }
    
    return url;
  };

  updatePreviewButton = (subdomain) => {
    if (subdomain && subdomain.length >= 3) {
      const url = this.buildSubdomainURL(subdomain);
      this.previewBtn.attr("href", url).removeClass("d-none");
    } else {
      this.previewBtn.addClass("d-none");
    }
  };

  onTemplateCardClick = (event) => {
    const card = $(event.currentTarget);
    const slug = (card.data("template-slug") || "").toString();
    if (!slug) {
      return;
    }
    this.selectedTemplateSlug = slug;
    this.updateSelectedTemplateName();
    this.renderTemplateCards();
    this.initLivePreview(this.subdomainInput.val());
  };

  onSubdomainInput = () => {
    const sanitized = this.sanitizeSubdomain(this.subdomainInput.val());
    this.subdomainInput.val(sanitized);
    this.updatePreviewButton(sanitized);

    clearTimeout(this.subdomainCheckTimeout);
    if (sanitized.length >= 3) {
      this.subdomainCheckTimeout = setTimeout(() => {
        this.initLivePreview(sanitized);
        this.checkSubdomainAvailability(sanitized);
      }, 1000);
    } else {
      this.showNotice("Subdomain too short", true);
    }
  };

  checkSubdomainAvailability = (subdomain) => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/checkSubdomainAvailability",
      headers: { Authorization: X_API_KEY },
      data: { subdomain: subdomain },
      success: (res) => {
        if (res.available) {
          this.showNotice("Available!", false);
        } else {
          this.showNotice("Already taken", true);
        }
      }
    });
  };

  sanitizeSubdomain = (value) => {
    return (value || "")
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-+|-+$/g, "");
  };

  initLivePreview = (subdomain) => {
    if (!subdomain || subdomain.length < 3) {
      this.previewIframe.attr("src", "about:blank");
      this.previewLoader.removeClass("d-none");
      return;
    }

    const url = this.buildSubdomainURL(subdomain, true);
    console.log("Loading Preview URL:", url);
    
    // Update full link fallback
    $("#vendorWebsitePreviewFullLink").attr("href", this.buildSubdomainURL(subdomain));
    
    // Ensure loader exists
    if (!document.getElementById('vendorWebsitePreviewLoader')) {
        const loaderHtml = `
            <div id="vendorWebsitePreviewLoader" class="position-absolute top-0 start-0 w-100 h-100 bg-white d-flex flex-column align-items-center justify-content-center" style="z-index: 10;">
                <div class="spinner-border text-red mb-3" role="status"></div>
                <p class="small text-muted">Connecting to preview...</p>
            </div>`;
        this.previewIframe.parent().append(loaderHtml);
    }
    
    // Reset loader with status
    $("#vendorWebsitePreviewLoader").removeClass("d-none").find('p').text("Connecting to preview...");
    
    this.previewIframe.attr("src", url);
    
    // Reveal logic with safety - THE SLEDGEHAMMER
    const forceHide = () => {
        const loader = document.getElementById('vendorWebsitePreviewLoader');
        if (loader) {
            console.log("Website Builder: Removing loader element from DOM.");
            loader.remove(); // Physically remove it so it can't stay visible
            try {
                this.syncLivePreview();
            } catch (e) {
                console.warn("Style sync failed after removal.", e);
            }
        }
    };

    // Listen for load
    this.previewIframe.on("load", () => {
        console.log("Website Builder: Iframe load confirmed.");
        forceHide();
    });

    // Fallback timer: absolutely must show after 3 seconds
    setTimeout(() => {
        console.log("Website Builder: Fallback reveal triggered.");
        forceHide();
    }, 4000);
  };

  syncLivePreview = () => {
    const styles = {
      primary: this.primaryColorInput.val(),
      secondary: this.secondaryColorInput.val(),
      font: $('input[name="font_family"]:checked').val(),
      radius: $('input[name="border_radius"]:checked').val()
    };

    const iframeWin = this.previewIframe[0].contentWindow;
    if (iframeWin) {
      iframeWin.postMessage({
        type: 'UPDATE_STYLES',
        styles: styles
      }, "*");
    }
  };

  updateSelectedTemplateName = () => {
    const template = this.templates.find((item) => item.slug === this.selectedTemplateSlug);
    this.selectedTemplateName.text(template ? template.name : "None");
  };

  updateStatusBadge = (status) => {
    const normalized = (status || "pending").toString().toLowerCase();
    const classes = {
      pending: "bg-warning text-dark",
      provisioned: "bg-success text-white",
      failed: "bg-danger text-white"
    };
    this.provisionStatusBadge.removeClass("bg-secondary bg-success bg-danger bg-warning text-white text-dark");
    this.provisionStatusBadge.addClass(classes[normalized] || "bg-secondary");
    this.provisionStatusBadge.text(normalized.toUpperCase());

    if (normalized === "provisioned") {
      const subdomain = this.sanitizeSubdomain(this.subdomainInput.val());
      if (subdomain && subdomain.length >= 3) {
        const liveUrl = this.buildSubdomainURL(subdomain);
        this.notice.removeClass("text-muted text-danger").addClass("text-success");
        this.notice.html(`
          <div class="mb-1"><i class="fa-solid fa-circle-check me-1"></i> Your website is live and secure!</div>
          <a href="${liveUrl}" target="_blank" class="text-red text-decoration-none fw-bold small">
            <i class="fa-solid fa-up-right-from-square me-1"></i> Visit: ${liveUrl.replace(/^https?:\/\//i, '')}
          </a>
        `);
      }
    }
  };

  saveSettings = () => {
    const subdomain = this.sanitizeSubdomain(this.subdomainInput.val());
    if (!this.selectedTemplateSlug) {
      this.showNotice("Please select a template first.", true);
      return;
    }
    if (subdomain.length < 3) {
      this.showNotice("Subdomain must be at least 3 characters.", true);
      return;
    }

    const payload = {
      template_slug: this.selectedTemplateSlug,
      subdomain: this.subdomainInput.val(),
      site_title: this.siteTitleInput.val(),
      primary_color: this.primaryColorInput.val(),
      secondary_color: this.secondaryColorInput.val(),
      font_family: $('input[name="font_family"]:checked').val(),
      border_radius: $('input[name="border_radius"]:checked').val(),
      social_instagram: this.instagramInput.val(),
      social_facebook: this.facebookInput.val(),
      social_whatsapp: this.whatsappInput.val(),
      meta_title: this.metaTitleInput.val(),
      meta_description: this.metaDescriptionInput.val(),
      meta_keywords: this.metaKeywordsInput.val(),
      seo_body: this.seoBodyInput.val()
    };

    this.saveBtn.prop("disabled", true).text("Publishing...");
    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/saveWebsiteBuilderData",
      headers: { Authorization: X_API_KEY },
      data: payload,
      success: (res) => {
        this.applySettings(res.settings || {});
        this.showNotice("Website settings updated successfully!");
      },
      error: (xhr) => {
        const message = xhr?.responseJSON?.Msg || "Could not update settings.";
        this.showNotice(message, true);
      },
      complete: () => {
        this.saveBtn.prop("disabled", false).text("Publish My Website");
      }
    });
  };

  generateSeoContent = () => {
    this.generateSeoBtn.prop("disabled", true).html('<i class="fa-solid fa-spinner fa-spin"></i>');
    
    $.ajax({
      type: "POST",
      url: baseURL + "api/Website_builder_ai/generate_site_content",
      headers: { Authorization: X_API_KEY },
      data: {
        focus_keywords: this.focusKeywordsInput.val(),
        service_area: this.serviceAreaInput.val()
      },
      success: (res) => {
        if (res.status === "success" && res.data) {
          const d = res.data;
          if (d.site_title) this.siteTitleInput.val(d.site_title);
          if (d.meta_title) this.metaTitleInput.val(d.meta_title);
          if (d.meta_description) this.metaDescriptionInput.val(d.meta_description);
          if (d.meta_keywords) this.metaKeywordsInput.val(d.meta_keywords);
          
          if (d.about_us) {
            const aboutText = typeof d.about_us === 'object' ? Object.values(d.about_us).join("\n\n") : d.about_us;
            this.seoBodyInput.val(aboutText);
          }
          
          this.showNotice("AI content generated! Review and Publish.");
          // Expand advanced fields
          const advancedFields = document.getElementById('advancedSeoFields');
          if (advancedFields) {
              advancedFields.classList.add('show');
          }
        }
      },
      error: () => {
        this.showNotice("AI generator is busy. Please try again.", true);
      },
      complete: () => {
        this.generateSeoBtn.prop("disabled", false).html('<i class="fa-solid fa-wand-magic-sparkles me-1"></i> Generate');
      }
    });
  };

  showNotice = (message, isError = false) => {
    this.notice.removeClass("text-muted text-danger text-success");
    this.notice.addClass(isError ? "text-danger" : "text-success");
    this.notice.text(message || "");
  };
}
